module.exports = __webpack_public_path__ + "img/lars_skibba.d2ded10c.jpg";